// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.search-container {
  padding-top: 10px;
  padding-bottom: 5px;
}

.table-container {
    max-height: 80vh; /* Adjust the maximum height as needed */
    overflow-y: auto;
  }

  .table-container thead {
    position: sticky;
    top: 0;
    background-color: #f5f5f5; /* Adjust the background color as needed */
    z-index: 1;
    padding-top: 10px;
  }

  .delete-button {
    background-color: #ff5252;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 16px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .delete-button:hover {
    background-color: #e03c3c;
  }
  
  .delete-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 82, 82, 0.5);
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/css/MyExperimentRuns.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;IACI,gBAAgB,EAAE,wCAAwC;IAC1D,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,yBAAyB,EAAE,0CAA0C;IACrE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,4CAA4C;EAC9C","sourcesContent":["\n.search-container {\n  padding-top: 10px;\n  padding-bottom: 5px;\n}\n\n.table-container {\n    max-height: 80vh; /* Adjust the maximum height as needed */\n    overflow-y: auto;\n  }\n\n  .table-container thead {\n    position: sticky;\n    top: 0;\n    background-color: #f5f5f5; /* Adjust the background color as needed */\n    z-index: 1;\n    padding-top: 10px;\n  }\n\n  .delete-button {\n    background-color: #ff5252;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 16px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .delete-button:hover {\n    background-color: #e03c3c;\n  }\n  \n  .delete-button:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(255, 82, 82, 0.5);\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
